import { createSelector } from 'reselect';

import { State, ViewType } from '@typings';
import { isNumber } from '@utils';

import { configSelector } from './config.selectors';

export const cacheSelector = (state: State) => state.cache;

export const permissionSelector = createSelector(
  cacheSelector,
  ({ permissions }) => permissions,
);

export const userClustersSelector = createSelector(
  cacheSelector,
  configSelector,
  ({ userClusters }, { clusters }) =>
    userClusters.filter(({ clusterName }) =>
      clusters.some(({ name }) => name === clusterName),
    ),
);

export const userOrganizationsSelector = createSelector(
  cacheSelector,
  ({ userOrganizations }) => userOrganizations,
);

export const viewTypeSelector = createSelector(
  cacheSelector,
  ({ viewType }) => {
    const isGridView = viewType === ViewType.Grid;
    const isListView = viewType === ViewType.List;

    return { viewType, isGridView, isListView };
  },
);

export const organizationsInvitesSelector = createSelector(
  cacheSelector,
  ({ organizationInvites }) => organizationInvites,
);

export const organizationCreditsSelector = createSelector(
  cacheSelector,
  ({
    organizationCredits: {
      organizationCredits,
      userOrganizationCredits,
      loading: organizationCreditsLoading,
    },
  }) => {
    const isOrganizationBalanceUnlimited = !isNumber(organizationCredits);
    const isUserOrganizationBalanceUnlimited = !isNumber(
      userOrganizationCredits,
    );

    return {
      organizationCredits,
      organizationCreditsLoading,
      userOrganizationCredits,
      isOrganizationBalanceUnlimited,
      isUserOrganizationBalanceUnlimited,
    };
  },
);
